import { RouteRecordRaw } from "vue-router";

export default {
  path: "/share/:guid",
  name: "SharePage",
  component: () => import("@/views/share/SharePage.vue"),
  meta: {
    title: "分享模板",
    ignoreAuth: true,
    hideMenu: true,
  },
} as RouteRecordRaw;
